// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1468":"7964c5532103b4ec","3274":"b93af8d6a145fef6","6729":"b8801a77656ea77a","8795":"bf8d2ae9bb8a44e7","8919":"0b87496ecee089f8"}[chunkId] + ".css";
};